import policy from '../modules/policy/locales/en.json';
import waComponents from './wa-components.json';

const combined = {
  ...policy,
  ...waComponents,
};

export default combined;
